export enum BlockPointAttribute {
  Zone1 = 986,
  Zone2 = 987,
  Zone3 = 988,
  Zone4 = 989,
  Zone5 = 990,
  Zone6 = 991,
}
